module.exports = "pegasus/assets/repeat-small.png";